const REG_EXP_EVERYTHING_EXCEPT_DIGITS = /\D/g;

export const getOnlyDigits = (str: string | null) => str ? str.replace(REG_EXP_EVERYTHING_EXCEPT_DIGITS, '') : '';
